import { render, staticRenderFns } from "./editBuilding.vue?vue&type=template&id=df8c5d58&scoped=true&"
import script from "./editBuilding.vue?vue&type=script&lang=js&"
export * from "./editBuilding.vue?vue&type=script&lang=js&"
import style0 from "./editBuilding.vue?vue&type=style&index=0&id=df8c5d58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8c5d58",
  null
  
)

export default component.exports